export default __webpack_public_path__ + "media/images/corp/bottom_frame4-4983c2d665078e0c01cef85cb1ee911d.png";